import { render, staticRenderFns } from "./PdfTemplate2.vue?vue&type=template&id=4ec06da1&scoped=true"
import script from "./PdfTemplate2.vue?vue&type=script&lang=js"
export * from "./PdfTemplate2.vue?vue&type=script&lang=js"
import style0 from "./PdfTemplate2.vue?vue&type=style&index=0&id=4ec06da1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec06da1",
  null
  
)

export default component.exports